import { pageDataLoadWindowMs } from "./NavigationProgress.constants";

import { type IQueryStateSnapshot } from "./NavigationProgress.types";

export const getIsFirstLoadPending = (
  queryGroups: Record<string, IQueryStateSnapshot | undefined>[],
  pageRenderedAt: number | null,
) => {
  if (pageRenderedAt == null) {
    return false;
  }

  const queriesSincePageRender = queryGroups
    .flatMap((queries) => Object.values(queries))
    .filter((query) => query?.startedTimeStamp != null && query.startedTimeStamp >= pageRenderedAt)
    .sort((first, second) => Number(first?.startedTimeStamp) - Number(second?.startedTimeStamp));

  let chainEnd = pageRenderedAt + pageDataLoadWindowMs;
  for (const query of queriesSincePageRender) {
    if (query == null || Number(query.startedTimeStamp) > chainEnd) {
      return false;
    }
    if (query.status === "pending" && query.data === undefined) {
      return true;
    }
    chainEnd = Math.max(chainEnd, (query.fulfilledTimeStamp ?? Number(query.startedTimeStamp)) + pageDataLoadWindowMs);
  }

  return false;
};
